import { Controller } from "@hotwired/stimulus";

// Copies the text of one field to the clipboard and says so on the button
export default class extends Controller {
  static targets = ["source", "label"];

  async copy() {
    const original = this.labelTarget.textContent;
    try {
      await navigator.clipboard.writeText(this.sourceTarget.value);
      this.labelTarget.textContent = "Copied";
    } catch (_) {
      this.sourceTarget.select();
      this.labelTarget.textContent = "Press Ctrl+C to copy";
    }
    setTimeout(() => (this.labelTarget.textContent = original), 2000);
  }
}
